import createEnum from 'lib/createEnum';

export const COMPOSITION_STAGES = createEnum('MESSAGE', 'EMAIL', 'NAME');
export const ERROR_BANNER_ANIMATION_TIME = 300;
export const ERRORS = createEnum('FILE_SIZE', 'FILE_ERROR', 'CONNECTION', 'RECONNECTING');
export const LOCATIONS = createEnum('ANSWER', 'CHAT', 'HOME', 'OFFICE_HOURS', 'SECURE_PAYMENT');
export const STAGES = createEnum('CHAT', 'CHAT_CLOSED', 'CHAT_THROTTLED', 'ONBOARDING', 'SELF_SERVICE');

export default {
  COMPOSITION_STAGES,
  ERRORS,
  LOCATIONS,
  STAGES,
};
